// React
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
// ライブラリ
import { ajax } from 'rxjs/ajax';
import { catchError, of } from 'rxjs';
import Swal from 'sweetalert2'
// ユーティリティ
import { menu } from '../../../../constants';
import { validationSchema } from '../../../../utils/validationUtils';
import { errorMessages } from '../../../../utils/messagesUtils';

import sty from '../../Settings/Settings.module.css';

const UpdateEmailConfirm = ({ onClick }) => {
    const navigate = useNavigate();

    // フォームのstateを更新
    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: 'onBlur', // フォーカスが外れたときにバリデーションを実行
    });

    // フォーム送信時の処理
    const onSubmit = (data) => {

        // request to server
        ajax({
            url: `${process.env.REACT_APP_API_BASE_URL}/settings/update-mail/complete`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: {
                code: data.code
            },
            withCredentials: true
        })
        .pipe(catchError(error => of(error)))
        .subscribe(
            async (fromServerResponse) => {

                if(fromServerResponse.response.message === "logout") {
                    // 現状は、メールアドレス変更はエンジニアのみ可能
                    navigate(menu.ENGINEER.SIGNIN.PATH)
                    return;
                }
                
                switch(fromServerResponse.status) {
                    case 200:
                        onClick();
                        break;

                    case 401:
                        await Swal.fire({
                            icon: 'error',
                            html: errorMessages.account_settings.authentication_failed,
                            customClass: {
                                htmlContainer: 'large-text'
                            }
                        })
                        break;

                    case 404:
                        await Swal.fire({
                            icon: 'error',
                            html: errorMessages.api.not_found,
                            customClass: {
                                htmlContainer: 'large-text'
                            }
                        })						
                        break;
                        
                    default:
                        await Swal.fire({ 
                            icon: 'error',
                            html: errorMessages.api.network_error,
                            customClass: {
                                htmlContainer: 'large-text'
                            }
                        })
                        break;
                }
            }
        );
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className={sty['form']} data-testid="profile-form">
            <div className="inner-container">
                <div className={sty['form__authentication-code']}>
                    <div className={sty['form__authentication-code-txt']}>
                        <label htmlFor="code">
                            <p className={sty['form__authentication-line-break']}>{`メールアドレスに届いたコードを入力してください。`}</p>
                        </label>
                        <input {...register('code', validationSchema.code)} className={sty['form__authentication-code-input']} type="number" id="code" autoComplete="one-time-code" pattern="[0-9]*" onWheel={(e) => e.target.blur()} />
                        {errors.code && <p className="form__validation-msg form__authentication-validation-msg">{errors.code.message}</p>}
                    </div>
                </div>
            </div>
            <div className="primary-btns">
                <button type="submit" className="primary-btn">認証</button>
            </div>
        </form>
    )
}

export default UpdateEmailConfirm;


